<template>
  <div class="menu">
    <el-menu
      @select="handleSelect"
      class="menuList"
      :default-active="$route.path"
      :router="true"
    >
      <!-- 首页 -->
      <el-menu-item
        index="/HomeIndex"
        class="menuNoChild"
        v-if="isFollower || isSignal"
      >
        <div class="mobileMenuItem">
          <svg-icon icon-class="MenuHome"></svg-icon>
          <span slot="title">{{ $t("Menu_Home") }}</span>
        </div>
      </el-menu-item>
      <!-- 跟随 -->
      <el-submenu index="1">
        <template slot="title">
          <svg-icon icon-class="FwMenuIcon"></svg-icon>
          <span slot="title">{{ $t("Menu_Followers") }}</span>
        </template>
        <el-menu-item-group>
          <!-- 被邀请 -->
          <el-menu-item index="/FollowInvited">
            {{ $t("Menu_Followers_Invited") }}
            <span class="invitedNum" v-if="followData.invited !== 0">
              {{ followData.invited }}
            </span>
          </el-menu-item>
          <!-- 跟随列表 -->
          <el-menu-item index="/MyFollow">
            {{ $t("Menu_Followers_FollowingList") }}
          </el-menu-item>
          <!-- 历史分润 -->
          <el-menu-item index="/FollowHistory">
            {{ $t("Menu_Followers_HistoricalProfit") }}
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <!-- 信号 -->
      <el-submenu index="2">
        <template slot="title">
          <svg-icon icon-class="FwWifiIcon"></svg-icon>
          <span slot="title">{{ $t("Menu_Signal") }}</span>
        </template>
        <el-menu-item-group>
          <!-- 信号源 -->
          <el-menu-item index="/MySignal">
            {{ $t("Menu_Signal_Source") }}
          </el-menu-item>
          <!-- 跟随账号汇总 -->
          <el-menu-item index="/FollowSymbol">
            {{ $t("Menu_Signal_AllFollowing") }}
          </el-menu-item>
          <!-- 历史分润 -->
          <el-menu-item index="/historicalProfit">
            {{ $t("Menu_Signal_HistoricalProfit") }}
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <!-- 历史 -->
      <el-menu-item index="/MyRecord" class="menuNoChild">
        <div class="mobileMenuItem">
          <svg-icon icon-class="MenuHistory"></svg-icon>
          <span slot="title">{{ $t("Menu_History") }}</span>
        </div>
      </el-menu-item>
      <!-- 帮助 -->
      <el-menu-item v-if="mobileFlag" index="/HelpCenter" class="menuNoChild">
        <div class="mobileMenuItem">
          <svg-icon icon-class="MenuMessage"></svg-icon>
          <span slot="title">{{ $t("Menu_Help") }}</span>
        </div>
      </el-menu-item>
      <!-- 信息 -->
      <el-menu-item v-if="mobileFlag" index="/MyMessage" class="menuNoChild">
        <div class="mobileMenuItem">
          <svg-icon icon-class="MessageIcon"></svg-icon>
          <span slot="title">{{ $t("Menu_Message") }}</span>
        </div>
      </el-menu-item>
      <!-- 时间 -->
      <el-menu-item
        v-if="mobileFlag"
        disabled
        index="/Disclaimers"
        class="menuNoChild"
      >
        <div class="mobileMenuItem">
          <svg-icon icon-class="Calendar" />
          <DateTime slot="title" />
        </div>
      </el-menu-item>
    </el-menu>
    <!-- 免责声明 -->
    <div class="FollowLogo">
      <div class="DisclaimersDiv" @click="disclaimersClick()">
        {{ $t("DisclaimersTitle") }}
      </div>
    </div>

    <div v-if="false" class="mobileMenuWrap">
      <div class="mobileMenu">
        <p @click="clickMenu()">
          <span>{{ $t(mobileTxtChoose) }}</span>
          <span v-if="chooseSignal !== ''" class="signalTxt">
            {{ "— " + checkPortfolio.portfolioName }}
          </span>
          <i :class="[isClick ? 'down' : 'up']" class="el-icon-arrow-down"></i>
        </p>
        <ul class="mobileMenuUl" v-if="isClick">
          <li
            v-for="(item, index) in menuList"
            :key="index"
            @click="goPath(item.path, item.icon, item.name, item.children)"
            :class="mobilePathChoose == item.path ? 'chooseMenuMobile' : ''"
          >
            <span>
              {{ $t(item.name) }}
              <i
                v-if="item.children"
                :class="[ischildIconClick ? 'down' : 'up']"
                class="el-icon-arrow-down"
              ></i>
            </span>
            <ol
              :class="[
                isChildClick && item.children ? 'show' : '',
                'menuChildOl',
              ]"
            >
              <li
                v-for="(subitem, subindex) in item.children"
                @click="
                  goPath(subitem.path, subitem.icon, subitem.name, 'childClick')
                "
                :class="
                  mobilePathChoose == subitem.path ? 'chooseMenuMobile' : ''
                "
                :key="subindex"
              >
                <b>{{ $t(subitem.name) }}</b>
              </li>
            </ol>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Bus from "../../plugins/bus";
import DateTime from "@/components/common/DateTime.vue";

export default {
  name: "Menu",
  components: {
    DateTime,
  },
  data() {
    return {
      mobileIconChoose: "FwMenuIcon",
      mobileTxtChoose: "",
      mobilePathChoose: "/MyFollow",
      isClick: false,
      isChildClick: false,
      ischildIconClick: false,
      isFollower: false,
      isSignal: false,
      followData: {},
    };
  },
  computed: {
    ...mapState(["mobileFlag", "checkPortfolio", "chooseSignal"]),
    menuList() {
      return [
        {
          path: "",
          icon: "FwMenuIcon",
          name: "Menu_Followers",
          children: [
            {
              path: "/MyFollow",
              icon: "FwMenuIcon",
              name: "Menu_Followers_FollowingList",
            },
            {
              path: "/FollowHistory",
              icon: "FwMenuIcon",
              name: "Menu_Followers_HistoricalProfit",
            },
          ],
        },
        {
          path: "/MySignal",
          icon: "FwWifiIcon",
          name: "Menu_Signal_Source",
        },
        {
          path: "/MyRecord",
          icon: "FwRecordIcon",
          name: "Menu_History",
        },
        {
          path: "/Disclaimers",
          icon: "FwRecordIcon",
          name: "DisclaimersTitle",
        },
      ];
    },
  },
  mounted() {
    this.getUserType();
    this.getSymbolInfo();
    if (this.mobileFlag) {
      if (this.$route.path !== "/MyAccount") {
        this.$store.commit("setChooseSignal", "");
      }
      this.menuList.forEach((item, index) => {
        if (item.path == this.$route.path) {
          this.mobileIconChoose = item.icon;
          this.mobileTxtChoose = item.name;
          this.mobilePathChoose = item.path;
        } else if (item.children) {
          item.children.forEach((subitem, indexs) => {
            if (subitem.path == this.$route.path) {
              this.mobileIconChoose = subitem.icon;
              this.mobileTxtChoose = subitem.name;
              this.mobilePathChoose = subitem.path;
            }
          });
        } else if (this.$route.path == "/MyAccount") {
          this.mobileTxtChoose = "Menu_Signal_Source";
        }
      });
    }
    Bus.$on("isInviteRefresh", (myMsg) => {
      if (myMsg) {
        this.getSymbolInfo();
      }
    });
  },
  methods: {
    getUserType() {
      this.$axios.get("/Api/home/usertype").then((res) => {
        let dt = res.data;
        if (dt.isSuccess) {
          this.isFollower = dt.result.isFollower;
          this.isSignal = dt.result.isSignal;
        } else {
          this.$notify.error({
            title: this.$t("Common_Prompt"),
            message: dt.result,
          });
        }
      });
    },
    clickMenu() {
      this.isClick = !this.isClick;
    },
    goPath(path, icon, txt, child) {
      if (path) {
        this.$router.push({ path: path });
        this.mobileIconChoose = icon;
        this.mobileTxtChoose = txt;
        this.mobilePathChoose = path;
        this.isClick = false;
        this.isChildClick = false;
        this.ischildIconClick = false;
        if (path !== "/MyAccount") {
          this.$store.commit("setChooseSignal", "");
        }
      } else {
        if (child && child !== "childClick") {
          this.isChildClick = !this.isChildClick;
          this.ischildIconClick = !this.ischildIconClick;
        } else {
          this.isClick = false;
        }
      }
    },
    getSymbolInfo() {
      this.$axios.get("/Api/home/index?needStatistics=false").then((res) => {
        let dt = res.data;
        if (dt.isSuccess) {
          this.followData = dt.result.followData;
        } else {
          this.$notify.error({
            title: this.$t("Common_Prompt"),
            message: dt.result,
          });
        }
      });
    },
    disclaimersClick() {
      this.$router.push({ path: "/Disclaimers" });
      Bus.$emit("isMobileMenu", false);
    },
    handleSelect() {
      Bus.$emit("isMobileMenu", false);
    },
  },
};
</script>
<style lang="less" scoped>
.menu {
  display: flex;
  flex-direction: column;
  width: 264px;
  height: 100%;
  background: #2f3554;
  position: relative;

  .FollowLogo {
    width: 125px;
    bottom: 40px;
    left: 50%;
    transform: translate(-50%, 0);
    position: absolute;

    span {
      display: inline-block;
      color: #959595;
      font-size: 12px;
      margin-bottom: 10px;
    }

    p {
      height: 1px;
      background: #3a3a3a;
      padding: 0;
      margin: 20px 0;
      width: 150%;
      margin-left: -25%;
    }

    .DisclaimersDiv {
      color: #ffffff;
      font-size: 14px;
      font-family: "PingFangSC-Regular";
      cursor: pointer;
      text-align: center;
      opacity: 0.5;
    }
  }

  .menuList {
    margin: 35px 0;
    min-width: 100%;

    .svg-icon {
      color: #ffffff;
      width: 22px;
      height: 22px;
    }

    .is-active {
      .svg-icon {
        color: #ffffff;
      }
    }
  }
  .invitedNum {
    border-radius: 17px;
    background: #4d71ff;
    color: #fff;
    font-family: "PingFangSC-Medium";
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding: 2px 6px;
  }
}

@media screen and (max-width: 1445px) {
  .menu {
    width: 285px;
    .logoImg {
      margin-left: -20px;
    }
  }
}

@media screen and (max-width: 1289px) {
  .menu {
    width: 300px;
  }
}
@media screen and (max-width: 1025px) {
  .menu {
    width: 20%;
    .FollowLogo {
      span {
        white-space: nowrap;
      }
      .logoImg {
        margin-left: -40px;
      }
    }
  }
}
@media screen and (max-width: 821px) {
  .menu {
    width: 20%;
    .FollowLogo {
      span {
        margin-left: -20px;
      }
      .logoImg {
        width: 200px;
        margin-left: -20px;
      }
      .DisclaimersDiv {
        margin-left: -20px;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .enHtml {
    .menu {
      .FollowLogo {
        margin-right: 15px;
      }

      .mobileMenu {
        p {
          margin-right: 15px;

          span {
            font-size: 18px;
          }
        }

        .mobileMenuUl {
          width: 200px;
        }
      }
    }
  }
  .Title {
    .menu {
      position: absolute;
      width: 100%;
      top: 45px;
      height: auto;
      .menuList {
        margin: 0;

        .is-disabled {
          opacity: 1;
        }
      }
      .FollowLogo {
        bottom: 15px;
      }
    }
  }
}
</style>
